import React from 'react'
import AlertsPage from './AlertsPage'

export default class ManageAnnouncementsPage extends React.Component{
    render(){
        return <AlertsPage isEdit={true} facilityId={this.props.facility.id}></AlertsPage>
    }
}